import { useEffect, useRef, useState } from 'react';

export const useIntersectionObserver = (callback: (isInView: boolean) => void) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    const currentlyVisible = entry.isIntersecting;

                    if (currentlyVisible && !isVisible) {
                        setIsVisible(true);
                        callback(true);
                    } else if (!currentlyVisible && isVisible) {
                        setIsVisible(false);
                        callback(false);
                    }
                });
            },
            {
                threshold: 0.5
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [callback, isVisible]);

    return { ref, isVisible };
};
